module.exports = "<div class=\"modal-header heading\"><button type=button class=close ng-click=modalCtrl.dismiss()>&times;</button><div class=modal-title>CANCEL TICKET AMENDMENT?</div></div><div class=modal-body><p>Are you sure you want to abort ticket amendment process?</p><p>All progress will be lost.</p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=modalCtrl.close()>YES</button> <button class=\"btn btn-kt\" ng-click=modalCtrl.dismiss()>NO</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ukrail/rail-amendment/rail-cancel-rebook-mode-modal.html
// module id = 3603
// module chunks = 0